import ResetEmailSent from './ResetEmailSent';
export type { ResetEmailSentProps } from './ResetEmailSent.types';

export default ResetEmailSent;
